const styles = theme => ({
  button: {
    '&:hover': {
      cursor: 'pointer',
    },
    border: '1px solid #ebebeb',
    fontWeight: '600',
    backgroundColor: '#fff',
  },
  cropping: {
    color: '#fff',
    backgroundColor: 'var(--jmi-blue)',
  },
  cancelButton: {
    backgroundColor: '#f44336',
    color: '#fff',
    '&:hover': {
      background: '#d2190b',
    },
  },
  saveButton: {
    color: '#fff',
    backgroundColor: '#71BF47',
    '&:hover': {
      background: '#4f8a30',
    },
    marginLeft: '8px',
  },
  cropButton: {
    marginRight: theme.spacing(2),
    '&:hover': {
      color: '#fff',
      background: 'var(--jmi-blue)',
    },
  },
  toolbar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '12px',
  },
  leftToolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  rightToolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  brightnessSlider: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: '175px',
    alignItems: 'center',
  },
  brightnessIcon: {
    color: 'var(--jmi-blue)',
    marginRight: theme.spacing(1),
  },
  brightnessIconDisabled: {
    color: '#bdbdbd',
  },
  saveAsNewButton: {
    color: '#fff',
    backgroundColor: 'var(--jmi-blue);',
    '&:hover': {
      backgroundColor: 'var(--jmi-blue-hover)',
    },
  },
});

export default styles;
